// Copyright (c) 2023 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import {
  DeleteRecentNarrativeRequest,
  SearchRecentNarrativesRequest
} from "../../generated/wisetime/user/preferences/v4/preferences_pb"

export const searchRecentNarratives = createAction<SearchRecentNarrativesRequest>("narratives/search-recent-narratives")
export const deleteRecentNarrative = createAction<DeleteRecentNarrativeRequest>("narratives/delete-recent-narrative")
